import { createFileRoute, Navigate } from "@tanstack/react-router";

import { useWorkspace } from "#app/lib/data/workspace-context";
import { useUserSettings } from "#app/lib/hooks/use-user-settings";
import { getDefaultRouteSuffix } from "#app/lib/default-route";
import { PageLoading } from "#app/components/loading/page-loading";
import { routePath } from "#app/lib/hooks/use-app-navigate";

function AppIndex() {
  const { activeWorkspace } = useWorkspace();
  const { preferences, isLoading } = useUserSettings();

  if (!activeWorkspace) {
    return <Navigate to="/workspace-select" />;
  }

  if (isLoading && !preferences) {
    return (
      <PageLoading delayed />
    );
  }

  const base = `/${activeWorkspace.urlPath}`;
  const suffix = getDefaultRouteSuffix(preferences?.defaultRoute);

  return <Navigate to={routePath(`${base}${suffix}`)} />;
}

export const Route = createFileRoute("/(app)/")({ component: AppIndex });
